import React from "react";

import { useWrapExperienceCardContext } from "./WrapExperienceContext";

const WrapExperienceProfile = () => {
  // GRAB AUTHOR PROFILE PICTURE AND LINK FROM HERE
  //   const { card } = useWrapExperienceCardContext();
  return (
    <div className="flex aspect-square flex-col rounded-full bg-blue-300 md:h-12"></div>
  );
};

export default WrapExperienceProfile;
